import { useEffect, useState } from "react";
import "./index.css";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import PortalLayout from "./Components/PortalLayout";
import Doctors from "./Pages/Doctors/Doctors";
import Medicines from "./Pages/Medicines/Medicines";
import RegisterUsers from "./Pages/RegisteredUsers/RegisterUsers";
import AddEditUsers from "./Pages/RegisteredUsers/AddEditUsers";
import LoginPage from "./Pages/Login/Login";
import Staff from "./Pages/Staff/Staff";
import AddEditStaff from "./Pages/Staff/AddEditStaff";
import AdminDashboard from "./Pages/Admin_Dashboard/AdminDashboard";
import AddEditDoctors from "./Pages/Doctors/AddEditDoctors";
import AddEditHR from "./Pages/RegisteredUsers/AddEditHR";
import AddEditDispenser from "./Pages/RegisteredUsers/AddEditDispenser";
import Cookies from "js-cookie";
import Patients from "./Pages/Patients/Patients";
import PatientDetails from "./Pages/Patients/PatientDetails";
import AddEditPatient from "./Pages/Patients/AddEditPatient";
import ProfitLoss from "./Pages/ProfitLoss/ProfitLoss";
import Income from "./Pages/DayClosing/Income";
import DoctorIncome from "./Pages/Doctors_Income/DoctorIncome";
import Purchases from "./Pages/Purchases/Purchases";
import PurchaseView from "./Pages/Purchases/PurchaseView";
import Ledger from "./Pages/SupplierLedger/Ledger";
import DistributorList from "./Pages/SupplierLedger/DistributorList";
import Stock from "./Pages/Stock/Stock";
import Sales from "./Pages/Sales/Sales";
import ByDate from "./Pages/DayClosing/ByDate";
import SaleByReceptionist from "./Pages/Sales_by_Receptionist/SaleByReceptionist";
import SalesReturn from "./Pages/SalesReturn/SalesReturn";
import Quantityledger from "./Pages/PharmacyLedger/Quantityledger";
import SalesPurchaseLedger from "./Pages/PharmacyLedger/Sales&PurchaseLedger";
import HospitalServicesLedger from "./Pages/HospitalServicesLedger/HospitalServicesLedger";
import Profilelosstable from "./Pages/PharmacyProfile&losstable/Profilelosstable";
import LostProducts from "./Pages/PharmacyLostProducts/Pharmacylostproduct";
import AddLostProduct from "./Pages/PharmacyLostProducts/AddPharmacylostproduct";
const COOKIE_NAME = "Q1JFVC1LRVkXIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSL=";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // 🔒 Function to check authentication
  const checkAuthentication = () => {
    const token = Cookies.get(COOKIE_NAME);
    setIsAuthenticated(!!token);
  };

  // 🔒 Check authentication on mount
  useEffect(() => {
    checkAuthentication();
    setIsLoading(false);
  }, []);

  // 🔒 Watch for cookie changes (login/logout)
  useEffect(() => {
    const checkInterval = setInterval(() => {
      checkAuthentication();
    }, 500); // Check every 500ms for cookie changes

    return () => clearInterval(checkInterval);
  }, []);

  // 🔒 Redirect unauthenticated users to login (only after auth check is complete)
  useEffect(() => {
    if (!isLoading && !isAuthenticated && location.pathname !== "/login") {
      navigate("/login");
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname]);

  // Show loading state while checking authentication
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin" replace />} />

      <Route
        path="/admin"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AdminDashboard />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/login"
        element={!isAuthenticated ? <LoginPage /> : <Navigate to="/admin" />}
      />

      <Route
        path="/admin/closing/date"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <ByDate />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/closing/month"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Income />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/staff"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Staff />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/staff/AddEditStaff"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AddEditStaff />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/register"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <RegisterUsers />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/register/AddEditUser"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AddEditUsers />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/register/AddEditHR"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AddEditHR />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/register/AddEditDispenser"
        element={
          isAuthenticated ? (
            <PortalLayout>
              {" "}
              <AddEditDispenser />{" "}
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/doctor"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Doctors />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/doctor/AddEditDoctor"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AddEditDoctors />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/patients"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Patients />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/patients/:id"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <PatientDetails />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/patients/AddEdit"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AddEditPatient />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/medicines"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Medicines />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/profitloss"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <ProfitLoss />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/hospital/hospitalservicesledger"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <HospitalServicesLedger />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/doctorincome"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <DoctorIncome />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/hospital/salebyreceptionist"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <SaleByReceptionist />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/pharmacy/purchases"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Purchases />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/pharmacy/purchases/purchaseview"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <PurchaseView />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/pharmacy/ledger"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Ledger />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/pharmacy/distributorList"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <DistributorList />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/pharmacy/stock"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Stock />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      <Route
        path="/admin/pharmacy/sale"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Sales />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/pharmacy/sale/return"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <SalesReturn />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/pharmacy/PharmacyProfile&losstable/Profilelosstable"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <Profilelosstable />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />  

      <Route
        path="/admin/pharmacy/LostProducts/lostproduct"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <LostProducts />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/pharmacy/LostProducts/addlostproduct"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <AddLostProduct />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin/pharmacy/pharmacyledger/salespurchaseledger"
        element={
          isAuthenticated ? (
            <PortalLayout>
              <SalesPurchaseLedger />
            </PortalLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
    </Routes>
  );
}

export default App;
